import { apim, aemAxiosInstance } from "@/constants/api"

import {
  getStockEndPoint,
  apimSubscriptionKey,
  apiBaseUrl,
  BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY,
  CORE_GLOBAL_CONFIG_URL,
} from "@/constants/"

import { CATALOG_PROJECTION_ENDPOINT } from "@/constants/routes"
import { bundleRequestBuilder } from "@/requestBuilders/productRequestBuilder"

/**
 * Retrieves products by their SKUs from the catalog projection endpoint.
 *
 * @param {String} skus - An array of SKU strings to query for products.
 * @return {Array} A promise that resolves to an array of product objects.
 *                              Returns an empty array if an error occurs or no products are found.
 */
export const getProductsBySku = async skus => {
  let query = ""
  skus.forEach((sku, i) => {
    query += `"${sku}"`
    if (i + 1 !== skus.length) query += ","
  })
  try {
    const res = await apim.get(
      `${CATALOG_PROJECTION_ENDPOINT}?where=masterVariant(sku in (${query})) or variants(sku in (${query}))`
    )
    const { data: { results = [] } = {} } = res || {}
    return results
  } catch (error) {
    const { response } = error || {}

    const { data: { error: errorMessaqge = "" } = {} } = response
    console.error("Error fetching products by SKU:", errorMessaqge)

    return []
  }
}

export const getBundleProductDetailsFromServer = async (slug, lwAppName) => {
  const payload = bundleRequestBuilder(lwAppName)

  aemAxiosInstance.defaults.headers.common[
    "Ocp-Apim-Subscription-Key"
  ] = `${apimSubscriptionKey}`
  const response = await aemAxiosInstance.post(
    `${apiBaseUrl}${BUNDLE_PDP_END_POINT_SUBSCRIPTION_KEY}${slug}`,
    payload
  )
  const { data: { response: { docs = [] } = {} } = {} } = response
  return docs[0] ?? {}
}

export const callGetConfigDataServerApi = async (locale, url) => {
  try {
    const { data: configData = {} } = await aemAxiosInstance({
      url: `${CORE_GLOBAL_CONFIG_URL}?caConfig=true&path=/${locale}${url}`,
      method: "GET",
    })
    return { data: configData }
  } catch (error) {
    const {
      response: {
        config: { headers, url = "" } = {},
        status = 500,
        statusText = "",
      } = {},
    } = error

    return { error: { headers, statusText, status, url } }
  }
}

export const getProductInventory = async (skus = []) => {
  try {
    const response = await apim.get(`${getStockEndPoint}/?sku=${skus}`)
    const { data: { results = [] } = {} } = response || {}

    return { inventories: results }
  } catch {
    const skusArray = skus.split(",")
    const results = skusArray.map(sku => {
      return {
        availableQuantity: 1,
        key: "OMS-US",
        sku,
      }
    })
    return { inventories: results, isError: true }
  }
}
